var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueskey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#1185FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100424_442990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.71466 4.89082C7.04458 5.90086 8.47506 7.94881 9.00026 9.04786C9.5255 7.94889 10.9559 5.90084 12.2859 4.89082C13.2455 4.16201 14.8003 3.5981 14.8003 5.39249C14.8003 5.75086 14.5972 8.40294 14.478 8.83349C14.064 10.3304 12.5552 10.7122 11.213 10.4811C13.559 10.885 14.1558 12.223 12.867 13.561C10.4192 16.102 9.34878 12.9234 9.07438 12.1089C9.0241 11.9596 9.00057 11.8898 9.00023 11.9492C8.99988 11.8898 8.97635 11.9596 8.92607 12.1089C8.65179 12.9234 7.58142 16.1021 5.13348 13.561C3.8446 12.223 4.44138 10.885 6.78742 10.4811C5.44526 10.7122 3.93642 10.3304 3.52242 8.83349C3.40329 8.40289 3.2002 5.75081 3.2002 5.39249C3.2002 3.5981 4.75504 4.16201 5.7146 4.89082H5.71466Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100424_442990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10.7234,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueskey);
export default __webpack_public_path__ + "static/media/blueskey.cb243111705d6b42c144ec4732237f37.svg";
export { ForwardRef as ReactComponent };